module.exports = __webpack_public_path__ + "img/benjike4.bd47b1a6.png";